import isEmpty from 'lodash/fp/isEmpty'

import type { Block, Content, InlineContent } from '@/types'

import Link from '@/components/Edition/Link'

export function isBlockEmpty(block: Block): boolean {
  return (
    ((isEmpty(block.content) ||
      block.content?.every(
        (content) =>
          (content.type === 'text' && isEmpty(content.text)) ||
          (content.type === 'link' &&
            (isEmpty(content.content) ||
              content.content.every((subContent) => isEmpty(subContent.text)))),
      )) &&
      (isEmpty(block.children) || block.children?.every(isBlockEmpty))) ??
    true
  )
}

function getClassName(contentItem: InlineContent) {
  if (contentItem.type !== 'text') {
    return undefined
  }

  let className = 'whitespace-pre-wrap'
  if (contentItem.styles.small) {
    className = `${className} text-body-2`
  }
  if (contentItem.styles.smaller) {
    className = `${className} text-caption`
  }
  if (contentItem.styles.bold) {
    className = 'font-weight-bold'
  }
  if (contentItem.styles.code) {
    className = `${className} text-decorative-purple-50 font-weight-median [font-family:monospace]`
  }
  if (contentItem.styles.italic) {
    className = `${className} italic`
  }
  if (contentItem.styles.strike) {
    className = `${className} line-through`
  }
  if (contentItem.styles.underline) {
    className = `${className} underline`
  }

  return className.trim()
}

export function processContent(
  content: Array<Content> | undefined,
  editionUuid: string,
  {
    debug = false,
    sponsorBlockId = undefined,
  }: { debug?: boolean; sponsorBlockId?: string } = {},
) {
  if (isEmpty(content)) {
    return false
  }

  const getContent = (contentItem: InlineContent, index: number) => {
    switch (contentItem.type) {
      case 'link': {
        return (
          <Link
            key={index}
            editionUuid={editionUuid}
            href={contentItem.href}
            sponsorBlockId={sponsorBlockId}
          >
            {processContent(contentItem.content, editionUuid, {
              sponsorBlockId,
            })}
          </Link>
        )
      }

      case 'text': {
        return (
          <span key={index} className={getClassName(contentItem)}>
            {contentItem.text}
          </span>
        )
      }

      default: {
        return false
      }
    }
  }

  return content?.map((contentItem, index) => {
    if (debug) {
      console.debug(contentItem)
    }

    return getContent(contentItem, index)
  })
}
